/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Empty_BodyInputs */

const en_recipes_empty_body = /** @type {(inputs: Recipes_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share a cooking video or recipe page to Dishly, or paste a link. We'll write the recipe, match ingredients and work out nutrition.`)
};

const de_recipes_empty_body = /** @type {(inputs: Recipes_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile ein Kochvideo oder eine Rezeptseite mit Dishly oder füge einen Link ein. Wir schreiben das Rezept, ordnen die Zutaten zu und berechnen die Nährwerte.`)
};

/**
* | output |
* | --- |
* | "Share a cooking video or recipe page to Dishly, or paste a link. We'll write the recipe, match ingredients and work out nutrition." |
*
* @param {Recipes_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_empty_body = /** @type {((inputs?: Recipes_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_empty_body(inputs)
	return en_recipes_empty_body(inputs)
});